<template>
    <div class="wrapper" >
        
        <MainBanner ref="mainBanner" v-show="scShopOnload"/>
        
        <section class="gray_section" style="border-top:none" v-show="scShopOnload">
            <div class="wrap">
                <h2 class="section_title">브랜드 선택 <router-link to="/brandList" style="font-weight:500; font-size:13px">전체보기<i class="far fa-chevron-right"></i></router-link></h2>
                <ul class="brand_list" style="position:relative; padding-top:0">
                    <template v-for="idx in 4">
                        <li v-if="brandItems.length >= idx" :key="`main-brand-item-${idx}`">
                            <router-link :to="`/vehicleList/${brandItems[idx-1].id}`">
                                <img class="wh100p box-sizing p-2" :src="brandItems[idx-1].url">
                            </router-link>
                        </li>
                    </template>
                </ul>
            </div>
        </section>

        <MainSc ref="mainSc" :onload="scShopOnload" v-show="scShopOnload"></MainSc>

        <MainAdBanner ref="mainAd" :onload="scShopOnload"></MainAdBanner>

        <!-- 최근 본 모델 -->
        <MainRecentCar></MainRecentCar>

        <MainShop ref="mainShop" :onload="scShopOnload" v-show="scShopOnload"></MainShop>

        <MainNews ref="mainNews" :onload="scShopOnload" v-show="scShopOnload"></MainNews>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MainBanner from './MainBanner.vue';
import MainAdBanner from './MainAdBanner.vue';
import MainRecentCar from './MainRecentCar.vue';
import MainSc from './MainSc.vue';
import MainShop from './MainShop.vue';
import MainNews from './MainNews.vue';

export default {
    name: 'Main',
    components: {
        MainBanner,
        MainAdBanner,
        MainRecentCar,
        MainSc,
        MainShop,
        MainNews,
    },
    data() {
        return {
            scShopOnload: false,
        }
    },
    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            currentLocationOnload: state => state.currentLocationOnload,
            onload: state => state.common.onload
        }),
    },

    watch: {
        currentLocationOnload : {
            handler (value) {
                if(value) this.getShopAndSc();
            },
            deep: true,
        },
    },

    created() {
        this.$store.state.header = false;
        this.$store.state.footer = true;
        this.$store.dispatch("GET_BRAND_LIST");

        this.getShopAndSc();

        if(
            this.agentCheck == this.Const.SOCIAL.OTHER ||
            this.currentLocationOnload == true && this.scShopOnload == false
        ) this.getShopAndSc();
    },

    methods: {
        async getShopAndSc() {

            this.$store.dispatch('GET_BRAND_LIST');

            await this.setCurrentLocation();

            try {
                await this.$refs.mainBanner.getMainImg();

                await this.$refs.mainSc.getItems();

                await this.$refs.mainAd.getItems();
  
                await this.$refs.mainShop.getItems();

                await this.$refs.mainNews.getItems();

                this.scShopOnload = true;
                this.$store.commit('SHOW_ONLOAD');
            } catch (error) {
                this.apiCatch(error);
            }
        },

        setCurrentLocation(){
            let lat = localStorage.getItem("CURRENT_LOCATION_LAT", lat);
            let har = localStorage.getItem("CURRENT_LOCATION_HAR", har);

            localStorage.removeItem("CURRENT_LOCATION_LAT");
            localStorage.removeItem("CURRENT_LOCATION_HAR");

            if(lat && har) {
                this.$store.commit('SET_CURRENT_LOCATION',{ lat, har });
                this.$store.commit('SET_CURRENT_LOCATION_ONLOAD');
            }
        },
    },

    

}
</script>